import './Navbar.css'
import { NavLogo, SliderBtn } from './NavbarElements'
import { CgFormatRight } from "react-icons/cg";


const Navbar = ({ toggle }) => {
  return (
    <>
        <div className='Nav'>
            <div className='NavbarContainer'>
                <NavLogo to='/'>
                  <div className='Navlogo'>
                  </div>
                </NavLogo>
                <div className='MobileIcon' onClick={toggle}>
                    <CgFormatRight className='icons'/>
                </div>
                <div className='NavMenu'>
                    <ul>
                        <SliderBtn to='/' smooth={true} duration={1000} className='NavLinks'>
                            Produkter
                        </SliderBtn>
                        <SliderBtn to='/about' smooth={true} duration={2500} offset={-100} className='NavLinks'>
                            Om Oss
                        </SliderBtn>
                        <SliderBtn to='/login' smooth={true} duration={2000} offset={-20} className='NavLinks'>
                            Logga In
                        </SliderBtn>
                    </ul>       
                </div>
            </div>
        </div>
    </>
  )
}

export default Navbar